/**
 * Resolve the IANA zone used for trade times, charts, and calendar-day queries.
 * When Display Preferences timezone mode is **auto**, use the device zone — not the API's
 * stored placeholder (often `"UTC"`).
 */

import { normalizeIanaTimeZone } from "./ianaTimezones";

export function deviceIanaTimeZone(): string {
  if (typeof Intl === "undefined") return "UTC";
  const raw = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  return normalizeIanaTimeZone(raw);
}

export function resolveUserReportingTimeZone(
  apiTimezone: string | null | undefined,
  timezoneSource: "auto" | "manual" | null | undefined
): string {
  const device = deviceIanaTimeZone();
  if (timezoneSource === "manual") {
    const manual = (apiTimezone || "").trim();
    if (manual) return manual;
  }
  return device;
}
